import { Link, useNavigate } from 'react-router-dom';
import echoLogo from '../../assets/newEchoLogo.png';
import rvceLogo from '../../assets/Logo-2.png';
import { useState, useMemo, useRef, useEffect } from 'react';
import {
    Box,
    Typography,
    Button,
    Tooltip,
    IconButton,
    useMediaQuery,
    useTheme,
    Card,
    Badge,
    Avatar,
    Menu,
    MenuItem,
    Dialog,
    DialogContent,
    Stack,
} from '@mui/material';
import InsightsIcon from '@mui/icons-material/Insights';
import CalendarTodayIcon from '@mui/icons-material/CalendarToday';
import ExploreIcon from '@mui/icons-material/Explore';
import NotificationsIcon from '@mui/icons-material/Notifications';
import { getUserById } from '../../service/user';

const moods = [
    { id: 'great', e: '😊', l: 'Great' },
    { id: 'good', e: '🙂', l: 'Good' },
    { id: 'okay', e: '😐', l: 'Okay' },
    { id: 'low', e: '😔', l: 'Low' },
    { id: 'stressed', e: '😰', l: 'Stressed' },
    { id: 'anxious', e: '😟', l: 'Anxious' },
];

// const posA = [
//     { i: '🎧', l: 'Echo Sound Therapy', c: 'snd', p: 'sound' },
//     { i: '🔍', l: 'Explore echoShine', c: 'exp', p: 'explore' },
// ];
// const goodA = [
//     { i: '🎧', l: 'Echo Sound Therapy', c: 'snd', p: 'sound' },
//     { i: '🫁', l: 'Breathing', c: 'bth', p: 'care' },
//     { i: '🧘', l: 'Daily Yoga', c: 'yga', p: 'care' },
//     { i: '🔍', l: 'Explore echoShine', c: 'exp', p: 'explore' },
// ];
// const supA = [
//     { i: '🎧', l: 'Echo Sound Therapy', c: 'snd', p: 'sound' },
//     { i: '🫁', l: 'Breathing', c: 'bth', p: 'care' },
//     { i: '🧘', l: 'Daily Yoga', c: 'yga', p: 'care' },
//     { i: '👩‍⚕️', l: 'Talk to a Counselor', c: 'cns', p: 'therapy' },
//     { i: '💬', l: 'Chat 24x7 with a Counsellor', c: 'ccn', p: 'converse' },
//     { i: '🔍', l: 'Explore echoShine', c: 'exp', p: 'explore' },
// ];

const posA = [
    { i: '🎧', l: 'Echo Sound Therapy', route: '/echo-sounds' },
    { i: '🔍', l: 'Explore echoShine', route: '/home' },
];

const goodA = [
    { i: '🎧', l: 'Echo Sound Therapy', route: '/echo-sounds' },
    { i: '🫁', l: 'Breathing', route: '/care' },
    { i: '🧘', l: 'Daily Yoga', route: '/care' },
    { i: '🔍', l: 'Explore echoShine', route: '/home' },
];

const supA = [
    { i: '🎧', l: 'Echo Sound Therapy', route: '/echo-sounds' },
    { i: '🫁', l: 'Breathing', route: '/care' },
    { i: '🧘', l: 'Daily Yoga', route: '/care' },
    { i: '👩‍⚕️', l: 'Talk to a Counselor', route: '/consult' },
    { i: '💬', l: 'Chat 24x7 with a Counsellor', route: '/converse' },
    { i: '🔍', l: 'Explore echoShine', route: '/home' },
];

// RVCE institution-specific action arrays
const rvcePosA = [
    { i: '🎧', l: 'Echo Sound Therapy', route: '/echo-sounds' },
    { i: '🔍', l: 'Explore echoShine', route: '/home' },
];

const rvceLowA = [
    { i: '🎧', l: 'Echo Sound Therapy', route: '/echo-sounds' },
    { i: '🔍', l: 'Explore echoShine', route: '/home' },
    { i: '🫁', l: 'Breathing', route: '/care' },
];

const rvceSupA = [
    { i: '🎧', l: 'Echo Sound Therapy', route: '/echo-sounds' },
    { i: '🔍', l: 'Explore echoShine', route: '/home' },
    { i: '🫁', l: 'Breathing', route: '/care' },
    { i: '📔', l: 'Gratitude Journal', route: '/gratitude-checkin' },
    { i: '🧠', l: 'Mood Check-in', route: '/mood-checkin' },
];

const actionColorMap = {
    snd: { border: '#FFB347', color: '#B8860B', hoverBg: '#FFF8ED' },
    exp: { border: '#5BA4F5', color: '#5BA4F5', hoverBg: '#EBF3FF' },
    bth: { border: '#FF6B8A', color: '#FF6B8A', hoverBg: '#FFF0F3' },
    yga: { border: '#2DD4A8', color: '#1AAB86', hoverBg: '#E8FBF5' },
    cns: { border: '#FF6B8A', color: '#FF6B8A', hoverBg: '#FFF0F3' },
    ccn: { border: '#9B7BFF', color: '#9B7BFF', hoverBg: '#F3EEFF' },
};

const bubbleStyleMap = {
    great: '',
    good: '',
    okay: 'warm',
    low: 'sup',
    stressed: 'care',
    anxious: 'care',
};

const bubbleBgMap = {
    '': '#E8FBF5',
    warm: '#FFF8ED',
    sup: '#F3EEFF',
    care: '#FFF0F3',
};

const bubbleHlMap = {
    '': '#1AAB86',
    warm: '#D4890A',
    sup: '#9B7BFF',
    care: '#FF6B8A',
};

function getGreeting() {
    const h = new Date().getHours();
    if (h < 12) return { t: 'Good Morning!', e: '☀️', p: 'morning' };
    if (h < 17) return { t: 'Good Afternoon!', e: '🌤️', p: 'afternoon' };
    return { t: 'Good Evening!', e: '🌙', p: 'evening' };
}

function getMotivationalMessages(period) {
    return {
        great: [
            `That spark in you today? <b style="color:VAR_HL">Hold onto it</b> 🔥. Days like this are when the best version of you shows up — let's make it count.`,
            `You woke up choosing joy — and that's <b style="color:VAR_HL">not a small thing</b> ☀️. Let's ride this wave and turn a great mood into a great ${period}.`,
            `When you feel this good, <b style="color:VAR_HL">your mind and body are in sync</b> 🎯. Perfect time to invest in something that keeps this rhythm going.`,
            `This is your energy at its peak 💎. <b style="color:VAR_HL">Protect this state</b> — a few minutes of intentional wellness can make this feeling last all day.`,
        ],
        good: [
            `Steady and grounded — that's <b style="color:VAR_HL">real inner strength</b> 🌿. A little intentional focus now could tip this into something truly great.`,
            `Good is underrated 💚. You're in a <b style="color:VAR_HL">balanced zone</b> right now — the ideal time to stack some wellness wins.`,
            `Your mind is clear and your vibe is calm 🍃. <b style="color:VAR_HL">This is where growth happens</b> — pick something that elevates you even further.`,
            `Feeling good means your foundation is solid 🏔️. <b style="color:VAR_HL">Let's build on it</b> — even 5 minutes of self-care can turn good into extraordinary.`,
        ],
        okay: [
            `'Okay' is honest — and <b style="color:VAR_HL">honesty is where healing starts</b> 🌤️. Let's see what might add a little colour to your ${period}.`,
            `You showed up, and <b style="color:VAR_HL">that matters more than you think</b> 🤝. Sometimes all it takes is one small thing to shift your day.`,
            `Middle ground doesn't mean stuck — it means <b style="color:VAR_HL">you're ready for a nudge</b> 💛. Let's find what moves the needle for you today.`,
        ],
        low: [
            `Low days don't define you — but <b style="color:VAR_HL">how you respond to them does</b> 🌊. You chose to check in, and that's already a win.`,
            `You don't have to fix everything right now 💙. Just <b style="color:VAR_HL">one gentle step</b> — a sound, a breath, a conversation — can shift things quietly.`,
            `Being here means you haven't given up on yourself, and <b style="color:VAR_HL">neither have we</b> 🤍. Let's find a soft landing for today.`,
        ],
        stressed: [
            `Your mind is running a marathon right now 🏃. Let's <b style="color:VAR_HL">hit the pause button</b> — even 3 minutes of calm can reset your entire nervous system.`,
            `Stress is just your body saying <b style="color:VAR_HL">"I need support"</b> 🧡. You've earned a break — let's find the one that fits this moment.`,
            `The weight you're carrying is real — but <b style="color:VAR_HL">you don't have to carry it alone</b> 🌻. Let's lighten the load, one step at a time.`,
        ],
        anxious: [
            `Right now, in this moment, <b style="color:VAR_HL">you are okay</b> 🕊️. Anxiety tells a loud story — but your breath can tell a quieter, truer one.`,
            `Your brain is on high alert, trying to keep you safe 💙. Let's <b style="color:VAR_HL">gently remind it that you're in control</b> — one calming moment at a time.`,
            `Anxiety shrinks when you <b style="color:VAR_HL">name it and face it</b> — and you just did 💜. That takes courage. Let's channel it into something soothing.`,
        ],
    };
}

const ppP = {
    great: ['🌟 What would you like to do next?', '🚀 Ready to make the most of this energy?', '✨ Pick something that matches your vibe:', '💪 You\'re on fire — what\'s next?'],
    good: ['🌿 What sounds good right now?', '💚 Keep the momentum going — choose one:', '🍃 What would feel good right now?', '☀️ Your pick — what\'s calling you today?'],
    okay: ['💛 Let\'s brighten your day — pick something:', '🌤️ A small step can shift everything:', '💫 What feels right for you right now?'],
    low: ['💙 We\'re here for you. How can we help?', '🤍 Take it slow — pick whatever feels gentle:', '🕊️ One small step. No pressure:'],
    stressed: ['🧡 Let\'s ease that tension. Choose what feels right:', '🌊 Time to decompress — what calls to you?', '🍵 Pick something calming — you\'ve earned it:'],
    anxious: ['💜 Let\'s find your calm. What speaks to you?', '🕊️ Ground yourself — pick what feels safe:', '💙 One soothing step at a time:'],
};

function pick(arr) {
    return arr[Math.floor(Math.random() * arr.length)];
}

function EchoHome({ setShowEchoHome }) {
    const navigate = useNavigate();
    const theme = useTheme();
    const moodTimeoutRef = useRef(null);
    const navigationCheckRef = useRef(false);
    const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
    // const storedUser = JSON.parse(localStorage.getItem("user") || "null");
    const [storedUser] = useState(() => {
        try {
            return JSON.parse(localStorage.getItem("user") || "null");
        } catch (error) {
            console.error("Invalid user data in localStorage:", error);
            return null;
        }
    });
    console.log("storedUser", storedUser)
    const institution = localStorage.getItem('institution');
    const isRvce = institution && institution.toLowerCase() === 'rvce';
    const [showVerificationModal, setShowVerificationModal] = useState(false);
    const [selectedMood, setSelectedMood] = useState(null);
    const [showTyping, setShowTyping] = useState(false);
    const [responseData, setResponseData] = useState(null);
    const [anchorEl, setAnchorEl] = useState(null);
    const open = Boolean(anchorEl);

    const handleClick = (event) => {
        setAnchorEl(event.currentTarget);
    };

    const handleClose = () => {
        setAnchorEl(null);
    };

    const responseRef = useRef(null);

    const greeting = useMemo(() => getGreeting(), []);
    const motP = useMemo(() => getMotivationalMessages(greeting.p), [greeting.p]);

    useEffect(() => {
        return () => {
            if (moodTimeoutRef.current) {
                clearTimeout(moodTimeoutRef.current);
            }
        };
    }, []);

    useEffect(() => {
        if (responseRef.current) {
            responseRef.current.scrollIntoView({ behavior: 'smooth', block: 'center' });
        }
    }, [showTyping, responseData]);

    // const handleProtectedNavigation = async (route) => {
    //     try {
    //         const userData = await getUserById(storedUser?.id);
    //         console.log("Fetched user:", userData);

    //         if (userData?.status === "verified") {
    //             navigate(route);
    //         } else {
    //             setShowVerificationModal(true);
    //         }

    //     } catch (error) {
    //         console.error("Error checking user status:", error);
    //     }
    // };

    // const handleMoodSelect = (moodId) => {

    //     setSelectedMood(moodId);
    //     setResponseData(null);
    //     setShowTyping(true);

    //     setTimeout(() => {
    //         const bubbleType = bubbleStyleMap[moodId];
    //         const hlColor = bubbleHlMap[bubbleType];
    //         const msg = pick(motP[moodId]).replace(/VAR_HL/g, hlColor);
    //         let acts;
    //         if (isRvce) {
    //             acts = (moodId === 'great' || moodId === 'good' || moodId === 'okay') ? rvcePosA
    //                 : moodId === 'low' ? rvceLowA
    //                     : rvceSupA;
    //         } else {
    //             acts = moodId === 'great' ? posA : (moodId === 'good' || moodId === 'okay') ? goodA : supA;
    //         }
    //         const prompt = pick(ppP[moodId]);

    //         setShowTyping(false);
    //         setResponseData({ msg, acts, prompt, bubbleType });
    //     }, 1200);
    // };

    const handleProtectedNavigation = async (route) => {
        if (navigationCheckRef.current) return;

        navigationCheckRef.current = true;

        try {
            const userData = await getUserById(storedUser?.id);

            if (userData?.status === "verified") {
                navigate(route);
            } else {
                setShowVerificationModal(true);
            }
        } catch (error) {
            console.error("Error checking user status:", error);
        } finally {
            navigationCheckRef.current = false;
        }
    };

    const handleMoodSelect = (moodId) => {
        // Clear previous mood timer
        if (moodTimeoutRef.current) {
            clearTimeout(moodTimeoutRef.current);
        }

        setSelectedMood(moodId);
        setResponseData(null);
        setShowTyping(true);

        moodTimeoutRef.current = setTimeout(() => {
            const bubbleType = bubbleStyleMap[moodId];
            const hlColor = bubbleHlMap[bubbleType];

            const msg = pick(motP[moodId]).replace(
                /VAR_HL/g,
                hlColor
            );

            let acts;

            if (isRvce) {
                acts =
                    moodId === 'great' ||
                        moodId === 'good' ||
                        moodId === 'okay'
                        ? rvcePosA
                        : moodId === 'low'
                            ? rvceLowA
                            : rvceSupA;
            } else {
                acts =
                    moodId === 'great'
                        ? posA
                        : moodId === 'good' || moodId === 'okay'
                            ? goodA
                            : supA;
            }

            const prompt = pick(ppP[moodId]);

            setShowTyping(false);
            setResponseData({
                msg,
                acts,
                prompt,
                bubbleType
            });

            moodTimeoutRef.current = null;
        }, 1200);
    };

    const handleActionClick = (page) => {
        if (page) {
            navigate('/' + page);
        }
    };

    const handleLogout = () => {
        handleClose();                  // close any menus/dialogs

        //  localStorage.clear();  
        // Preserve domain and institution
        const domain = localStorage.getItem('domain');
        const institution = localStorage.getItem('institution');
        setShowEchoHome(false);
        // Clear all localStorage
        localStorage.clear();

        // Restore domain and institution
        if (domain) localStorage.setItem('domain', domain);
        if (institution) localStorage.setItem('institution', institution);

        navigate('/', { replace: true }); // redirect to login and replace history
    };


    const handleProfile = () => {
        handleClose();
        navigate('/profile');
    };

    const handleStartJourney = async () => {
        try {
            const userData = await getUserById(storedUser?.id);
            console.log("Fetched user:", userData);

            if (userData?.status === "verified") {
                navigate("/echo-sounds");
            } else {
                setShowVerificationModal(true);
            }

        } catch (error) {
            console.error("Error checking user status:", error);
        }
    };

    const handleExplore = async () => {
        try {
            const userData = await getUserById(storedUser?.id);
            console.log("Fetched user:", userData);

            if (userData?.status === "verified") {
                navigate('/home');
            } else {
                setShowVerificationModal(true);
            }

        } catch (error) {
            console.error("Error checking user status:", error);
        }
    };

    return (
        <Box sx={{
            minHeight: '100vh',
            background: 'linear-gradient(135deg, #f8fffe 0%, #f5f3ff 100%)',
            position: 'relative',
            overflow: 'hidden',
            '&::before': {
                content: '""',
                position: 'fixed',
                inset: 0,
                background: 'radial-gradient(ellipse at 20% 0%, rgba(45,212,168,0.06) 0%, transparent 50%), radial-gradient(ellipse at 80% 100%, rgba(255,107,138,0.05) 0%, transparent 50%)',
                pointerEvents: 'none',
                zIndex: 0,
            },
        }}>
            {/* 🔥 Top Left Branding */}
            {/* 🔥 Top Branding */}
            {/* <Box
                sx={{
                    width: '100%',
                    display: 'flex',
                    alignItems: 'center',
                    padding: '20px 24px',
                    justifyContent: "space-between"
                }}
            > */}
            <Box
                sx={{
                    width: '100%',
                    display: 'flex',
                    alignItems: 'center',
                    flexWrap: 'wrap',
                    rowGap: 1,
                    padding: { xs: '12px 16px', sm: '16px 20px', md: '20px 24px' },
                    justifyContent: 'space-between',
                }}
            >
                <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5 }}>
                    <Link
                        to="/"
                        style={{
                            textDecoration: 'none',
                            display: 'flex',
                            alignItems: 'center',
                        }}
                    >
                        {/* <Box
                            component="img"
                            src="/diginxthlt-logo.svg"
                            alt="Echo Logo"
                            sx={{
                                height: 45,
                                width: 45,
                                mr: 1,
                            }}
                        />

                        <Box>
                            <Typography
                                sx={{
                                    fontSize: '1.4rem',
                                    fontWeight: 700,
                                    letterSpacing: '0.5px',
                                    color: "#7843f3",
                                    lineHeight: 1.1,
                                }}
                            >
                                echoShine
                            </Typography>

                            <Typography
                                sx={{
                                    fontSize: '0.7rem',
                                    fontWeight: 500,
                                    letterSpacing: '0.3px',
                                    color: "#7843f3",
                                }}
                            >
                                Connect. Heal. Rise.
                            </Typography>
                        </Box> */}
                        <Box
                            component="img"
                            src="/diginxthlt-logo.svg"
                            alt="Echo Logo"
                            sx={{
                                height: { xs: 34, sm: 40, md: 45 },
                                width: { xs: 34, sm: 40, md: 45 },
                                mr: 1,
                            }}
                        />

                        <Box>
                            <Typography
                                sx={{
                                    fontSize: { xs: '1.05rem', sm: '1.2rem', md: '1.4rem' },
                                    fontWeight: 700,
                                    letterSpacing: '0.5px',
                                    color: "#7843f3",
                                    lineHeight: 1.1,
                                }}
                            >
                                echoShine
                            </Typography>
                            <Typography
                                sx={{
                                    fontSize: { xs: '0.6rem', sm: '0.65rem', md: '0.7rem' },
                                    fontWeight: 500,
                                    letterSpacing: '0.3px',
                                    color: "#7843f3",
                                }}
                            >
                                Connect. Heal. Rise.
                            </Typography>
                        </Box>
                    </Link>
                    {/* {isRvce && (
                        <Box
                            component="img"
                            src={rvceLogo}
                            alt="RVCE"
                            sx={{ height: 55, width: 'auto', objectFit: 'contain', ml: 1 }}
                        />
                    )} */}
                    {isRvce && (
                        <Box
                            component="img"
                            src={rvceLogo}
                            alt="RVCE"
                            sx={{ height: { xs: 38, sm: 46, md: 55 }, width: 'auto', objectFit: 'contain', ml: 1 }}
                        />
                    )}
                </Box>
                {/* <Box sx={{ display: 'flex', alignItems: 'center', mt: 2 }}>

                    <IconButton
                        onClick={handleClick}
                        sx={{ ml: 2 }} disableRipple>
                        <Avatar src={'/user.png'}
                            sx={{
                                width: 33,
                                height: 33,
                                bgcolor: '#E8E8E8'
                            }}
                        />
                    </IconButton>
                    <Typography variant="body2" sx={{ ml: 1, fontWeight: 500 }}>
                        Hello {storedUser?.name?.replace(/\b\w/g, (char) => char.toUpperCase()) || "Guest"}
                    </Typography>
                </Box> */}
                <Box sx={{ display: 'flex', alignItems: 'center', mt: { xs: 0, sm: 1 }, minWidth: 0 }}>
                    <IconButton onClick={handleClick} sx={{ ml: { xs: 0, sm: 2 } }} disableRipple>
                        <Avatar
                            src={'/user.png'}
                            sx={{
                                width: { xs: 30, sm: 33 },
                                height: { xs: 30, sm: 33 },
                                bgcolor: '#E8E8E8'
                            }}
                        />
                    </IconButton>
                    <Typography
                        variant="body2"
                        sx={{
                            ml: 1,
                            fontWeight: 500,
                            fontSize: { xs: '0.8rem', sm: '0.875rem' },
                            whiteSpace: 'nowrap',
                            overflow: 'hidden',
                            textOverflow: 'ellipsis',
                            maxWidth: { xs: 110, sm: 160, md: 220 },
                        }}
                    >
                        Hello {storedUser?.name?.replace(/\b\w/g, (char) => char.toUpperCase()) || "Guest"}
                    </Typography>
                </Box>
                <Menu
                    anchorEl={anchorEl}
                    open={open}
                    onClose={handleClose}
                    anchorOrigin={{
                        vertical: 'bottom',
                        horizontal: 'left',
                    }}
                    transformOrigin={{
                        vertical: 'top',
                        horizontal: 'left',
                    }}
                    PaperProps={{
                        sx: {
                            minWidth: 120,
                            width: '220px',
                        }
                    }}
                >
                    <MenuItem
                        onClick={handleProfile}
                    >
                        Profile
                    </MenuItem>

                    <MenuItem
                        onClick={handleLogout}
                    >
                        Logout
                    </MenuItem>
                </Menu>
            </Box>



            {/* ===== MAIN CONTENT ===== */}
            {/* <Box sx={{ maxWidth: 900, margin: '0 auto', padding: '28px 24px 60px', position: 'relative', zIndex: 1 }}> */}
            <Box sx={{
                maxWidth: 900,
                margin: '0 auto',
                padding: { xs: '16px 16px 40px', sm: '20px 20px 50px', md: '28px 24px 60px' },
                position: 'relative',
                zIndex: 1
            }}>

                {/* Greeting */}
                <Box sx={{ marginBottom: '24px' }}>
                    <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', flexWrap: 'wrap', gap: 1.5, }}>
                        <Box>
                            <Box display="flex" flexWrap="wrap" alignItems="center" columnGap={1} >
                                <Typography
                                    variant="h4"
                                    sx={{
                                        fontWeight: 700,
                                        // background: 'linear-gradient(135deg, #103680 0%, #4C41FF 100%)',
                                        background: 'linear-gradient(135deg, #22c55e, #14b8a6, #8b5cf6)',
                                        backgroundClip: 'text',
                                        WebkitBackgroundClip: 'text',
                                        WebkitTextFillColor: 'transparent',
                                        fontSize: { xs: '20px', sm: '24px', md: '28px' }
                                    }}
                                >
                                    {greeting.t}
                                </Typography>
                                <Typography
                                    variant="h4"
                                    sx={{
                                        fontWeight: 700,

                                        fontSize: { xs: '20px', sm: '24px', md: '28px' }
                                    }}
                                >
                                    {greeting.e}
                                </Typography>
                            </Box>
                            {/* <Typography sx={{ fontSize: 15, color: '#5A6B7D' }}>
                                Let's make today a great day for your wellbeing.
                            </Typography> */}
                            <Typography sx={{ fontSize: { xs: 13, sm: 14, md: 15 }, color: '#5A6B7D' }}>
                                Let's make today a great day for your wellbeing.
                            </Typography>
                        </Box>
                        <Box sx={{
                            display: 'flex',
                            gap: isMobile ? 2 : 1.5,
                            justifyContent: isMobile ? 'center' : 'flex-end',
                            order: isMobile ? 2 : 1,
                            flexWrap: 'wrap'
                        }}>
                            {/* <Tooltip title="Insights" arrow>
                                <IconButton
                                    onClick={() => navigate("/insights")}
                                    sx={{
                                        width: isMobile ? 38 : 44,
                                        height: isMobile ? 38 : 44,
                                        // backgroundColor: 'rgba(74, 108, 247, 0.1)',
                                        color: '#4a6cf7',
                                        '&:hover': {
                                            backgroundColor: 'rgba(74, 108, 247, 0.2)',
                                            transform: 'scale(1.05)'
                                        },
                                        transition: 'all 0.2s ease',
                                        background: 'linear-gradient(135deg, #22c55e, #14b8a6, #8b5cf6)',
                                        color: '#fff',
                                    }}
                                >
                                    <InsightsIcon fontSize={isMobile ? "small" : "small"} />
                                </IconButton>
                            </Tooltip> */}
                            <Tooltip title="Explore" arrow>
                                <IconButton
                                    onClick={handleExplore}
                                    sx={{
                                        width: isMobile ? 38 : 44,
                                        height: isMobile ? 38 : 44,
                                        // backgroundColor: 'rgba(34, 197, 94, 0.1)',
                                        // color: '#22c55e',
                                        color: '#fff',
                                        '&:hover': {
                                            backgroundColor: 'rgba(34, 197, 94, 0.2)',
                                            transform: 'scale(1.05)'
                                        },
                                        transition: 'all 0.2s ease',
                                        background: 'linear-gradient(135deg, #22c55e, #14b8a6, #8b5cf6)',

                                    }}
                                >
                                    <ExploreIcon fontSize={isMobile ? "small" : "small"} />
                                </IconButton>
                            </Tooltip>
                        </Box>
                    </Box>
                </Box>

                {/* Sound Therapy Banner */}
                {/* <Box sx={{
                    background: 'linear-gradient(135deg, #0fb5ae 0%, #2DD4A8 40%, #1AAB86 100%)',
                    borderRadius: '24px',
                    padding: '24px 28px',
                    display: 'flex', alignItems: 'center', justifyContent: 'space-between',
                    marginBottom: '24px',
                    position: 'relative', overflow: 'hidden',
                    '&::before': {
                        content: '""', position: 'absolute', inset: 0,
                        background: 'radial-gradient(circle at 80% 50%, rgba(255,255,255,0.15), transparent 60%)',
                    },
                }}>
                    <Box sx={{ position: 'relative', zIndex: 1 }}>
                        <Box sx={{
                            width: 44, height: 44,
                            background: 'rgba(255,255,255,0.2)', borderRadius: '12px',
                            display: 'flex', alignItems: 'center', justifyContent: 'center',
                            fontSize: 20, mb: '10px',
                        }}>🎧</Box>
                        <Typography sx={{ fontFamily: "'Outfit'", fontSize: 18, fontWeight: 700, color: '#fff', mb: '3px' }}>
                            AI-Powered Sound Therapy
                        </Typography>
                        <Typography sx={{ fontSize: 13, color: 'rgba(255,255,255,0.85)', mb: '6px' }}>
                            Personalized soundscapes for relaxation, focus & sleep
                        </Typography>
                        <Box sx={{
                            display: 'inline-flex', alignItems: 'center', gap: '5px',
                            background: 'rgba(255,255,255,0.2)', padding: '3px 10px',
                            borderRadius: '16px', fontSize: 11, fontWeight: 600, color: '#fff',
                        }}>
                            <Box sx={{ width: 6, height: 6, background: '#4ADE80', borderRadius: '50%' }} />
                            Powered by echoShine
                        </Box>
                    </Box>
                    <Button
                        onClick={() => navigate('/sound')}
                        sx={{
                            position: 'relative', zIndex: 1,
                            padding: '12px 24px', background: '#fff', border: 'none',
                            borderRadius: '12px', fontSize: 14,
                            fontWeight: 700, color: '#1AAB86', cursor: 'pointer',
                            display: 'flex', alignItems: 'center', gap: '6px',
                            textTransform: 'none',
                            boxShadow: '0 4px 16px rgba(0,0,0,0.1)',
                            transition: '0.25s',
                            '&:hover': { transform: 'translateY(-2px)', background: '#fff' },
                        }}
                    >
                        🎧 Try Now
                    </Button>
                </Box> */}

                <Card
                    sx={{
                        maxWidth: '850px',
                        width: '100%',
                        cursor: 'pointer',
                        transition: 'all 0.3s',
                        '&:hover': {
                            transform: 'translateX(4px)',
                            boxShadow: 3,
                            borderColor: 'primary.main'
                        },
                        borderRadius: 3,
                        border: '1px solid #e0e0e0',
                        // p: 2,               // reduced padding
                        p: { xs: 2, sm: 2.5, md: 3 },
                        mb: 1.5,              // reduced margin
                        display: 'flex',
                        flexDirection: 'column',
                        alignItems: 'flex-start',
                        gap: 1,               // reduced gap
                        textAlign: 'left',
                        background: 'linear-gradient(135deg, #f8fffe 0%, #f5f3ff 100%)',
                    }}
                >
                    <Typography variant="h6" fontWeight={600} sx={{
                        fontSize: { xs: '1.05rem', sm: '1.15rem', md: '1.25rem' },
                        background: 'linear-gradient(135deg, #22c55e, #14b8a6, #8b5cf6)',
                        WebkitBackgroundClip: 'text',
                        WebkitTextFillColor: 'transparent',
                    }}>
                        🎵 AI-Powered Sound Therapy
                    </Typography>

                    <Typography variant="body2" color="text.secondary" sx={{ fontSize: { xs: '0.85rem', sm: '0.9rem' } }}>
                        Based on your mood and heart rate, echoShine designs personalized therapeutic
                        music to elevate your mind and well-being.
                    </Typography>

                    <Button
                        variant="contained"
                        onClick={handleStartJourney}
                        sx={{
                            mt: 0.5,
                            borderRadius: 2,
                            textTransform: "none",
                            fontWeight: 600,
                            fontSize: "12px",     // ↓ smaller text
                            px: 1.5,              // ↓ shorter width padding
                            py: 0.3,              // ↓ shorter height padding
                            minWidth: "auto",      // removes MUI default 64px width
                            background: 'linear-gradient(135deg, #22c55e, #14b8a6, #8b5cf6)',

                        }}
                    >
                        Start Your Journey
                    </Button>

                </Card>

                {/* Mood Section */}
                <Box sx={{
                    background: '#FFF', borderRadius: '24px',
                    padding: '24px ',
                    padding: { xs: '16px 18px', sm: '20px 24px', md: '24px 28px' },
                    boxShadow: '0 2px 8px rgba(0,0,0,0.04)',
                    border: '1px solid rgba(0,0,0,0.04)',
                    marginBottom: '24px',
                }}>
                    <Box sx={{
                        display: 'flex', alignItems: 'center', justifyContent: 'space-between', mb: '20px', gap: '8px',
                        padding: { xs: '12px 14px', sm: '16px 20px' },
                        borderRadius: '16px',
                        minWidth: { xs: 72, sm: 90 },
                    }}>
                        <Typography sx={{ fontSize: 18, fontWeight: 600, display: 'flex', alignItems: 'center', gap: '8px' }}>
                            🔮 How are you feeling today?
                        </Typography>
                    </Box>
                    <Box sx={{ display: 'flex', justifyContent: 'center', gap: '14px', flexWrap: 'wrap' }}>
                        {moods.map((m) => (
                            <Box
                                key={m.id}
                                onClick={() => handleMoodSelect(m.id)}
                                sx={{
                                    display: 'flex', flexDirection: 'column', alignItems: 'center',
                                    gap: '8px', padding: '16px 20px', borderRadius: '16px',
                                    border: selectedMood === m.id ? '2px solid #2DD4A8' : '2px solid rgba(0,0,0,0.06)',
                                    background: selectedMood === m.id ? '#E8FBF5' : '#FAFCFB',
                                    cursor: 'pointer',
                                    transition: 'all 0.3s cubic-bezier(0.34,1.56,0.64,1)',
                                    minWidth: 90, userSelect: 'none',
                                    boxShadow: selectedMood === m.id ? '0 4px 24px rgba(45,212,168,0.25)' : 'none',
                                    transform: selectedMood === m.id ? 'translateY(-4px) scale(1.05)' : 'none',
                                    '&:hover': {
                                        transform: 'translateY(-4px) scale(1.03)',
                                        borderColor: '#2DD4A8',
                                        boxShadow: '0 4px 24px rgba(45,212,168,0.25)',
                                    },
                                }}
                            >
                                <Box sx={{ fontSize: { xs: 26, sm: 34 }, lineHeight: 1 }}>{m.e}</Box>
                                <Typography sx={{
                                    fontSize: 13, fontWeight: 600,
                                    color: selectedMood === m.id ? '#1AAB86' : '#5A6B7D',
                                }}>{m.l}</Typography>
                            </Box>
                        ))}
                    </Box>
                </Box>

                {/* AI Response Section */}
                {(showTyping || responseData) && (
                    <Box
                        ref={responseRef}
                        sx={{
                            background: '#FFF', borderRadius: '24px',
                            padding: '24px 28px',
                            boxShadow: '0 2px 8px rgba(0,0,0,0.04)',
                            border: '1px solid rgba(0,0,0,0.04)',
                            marginBottom: '24px',
                            animation: 'fadeSlideIn 0.5s ease-out',
                            '@keyframes fadeSlideIn': {
                                from: { opacity: 0, transform: 'translateY(16px)' },
                                to: { opacity: 1, transform: 'translateY(0)' },
                            },
                        }}
                    >
                        {showTyping ? (
                            <Box sx={{ display: 'flex', alignItems: 'flex-start', gap: '12px' }}>
                                <Box sx={{
                                    width: 38, height: 38, borderRadius: '10px',
                                    flexShrink: 0,
                                    boxShadow: '0 4px 24px rgba(45,212,168,0.25)',
                                }}><Box component="img" src={echoLogo} alt="echoShine" sx={{ width: 38, height: 38, borderRadius: '10px', objectFit: 'cover' }} /></Box>
                                <Box sx={{ display: 'flex', gap: '4px', padding: '8px 0' }}>
                                    {[0, 1, 2].map((i) => (
                                        <Box key={i} sx={{
                                            width: 7, height: 7, background: '#2DD4A8', borderRadius: '50%',
                                            animation: 'typingDot 1.4s infinite',
                                            animationDelay: `${i * 0.2}s`,
                                            '@keyframes typingDot': {
                                                '0%, 60%, 100%': { opacity: 0.3, transform: 'translateY(0)' },
                                                '30%': { opacity: 1, transform: 'translateY(-4px)' },
                                            },
                                        }} />
                                    ))}
                                </Box>
                            </Box>
                        ) : responseData && (
                            <>
                                <Box sx={{ display: 'flex', alignItems: 'flex-start', gap: '12px', mb: '16px' }}>
                                    <Box sx={{
                                        width: 38, height: 38, borderRadius: '10px',
                                        flexShrink: 0,
                                        boxShadow: '0 4px 24px rgba(45,212,168,0.25)',
                                    }}><Box component="img" src={echoLogo} alt="echoShine" sx={{ width: 38, height: 38, borderRadius: '10px', objectFit: 'cover' }} /></Box>
                                    <Box
                                        // sx={{
                                        //     background: bubbleBgMap[responseData.bubbleType],
                                        //     borderRadius: '4px 14px 14px 14px',
                                        //     padding: '14px 18px', fontSize: 14, lineHeight: 1.6,
                                        //     maxWidth: 580,
                                        // }}
                                        sx={{
                                            background: bubbleBgMap[responseData.bubbleType],
                                            borderRadius: '4px 14px 14px 14px',
                                            padding: { xs: '12px 14px', sm: '14px 18px' },
                                            fontSize: { xs: 13, sm: 14 },
                                            lineHeight: 1.6,
                                            maxWidth: { xs: '100%', sm: 480, md: 580 },
                                        }}
                                        dangerouslySetInnerHTML={{ __html: responseData.msg }}
                                    />
                                </Box>
                                <Box sx={{ mt: '10px' }}>
                                    <Typography sx={{
                                        fontFamily: "'Outfit'", fontSize: 16, fontWeight: 600,
                                        mb: '14px', display: 'flex', alignItems: 'center', gap: '6px',
                                    }}>
                                        {responseData.prompt}
                                    </Typography>
                                    <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: '10px' }}>
                                        {/* {responseData.acts.map((a, idx) => {
                                            const colors = actionColorMap[a.c] || { border: '#2DD4A8', color: '#1AAB86', hoverBg: '#E8FBF5' };
                                            return (
                                                <Button
                                                    key={idx}
                                                    onClick={() => handleActionClick(a.p)}
                                                    sx={{
                                                        display: 'flex', alignItems: 'center', gap: '6px',
                                                        padding: '10px 20px', borderRadius: '36px',
                                                        border: `2px solid ${colors.border}`,
                                                        background: '#fff',
                                                        fontSize: 13, fontWeight: 600,
                                                        color: colors.color, cursor: 'pointer',
                                                        textTransform: 'none', whiteSpace: 'nowrap',
                                                        transition: 'all 0.3s cubic-bezier(0.34,1.56,0.64,1)',
                                                        '&:hover': {
                                                            transform: 'translateY(-3px) scale(1.04)',
                                                            background: colors.hoverBg,
                                                        },
                                                    }}
                                                >
                                                    {a.i} {a.l}
                                                </Button>
                                            );
                                        })} */}
                                        {responseData.acts.map((a, idx) => (
                                            <Button
                                                key={idx}
                                                // onClick={() => navigate(a.route)}
                                                onClick={() => handleProtectedNavigation(a.route)}
                                                sx={{
                                                    display: 'flex',
                                                    alignItems: 'center',
                                                    gap: '6px',
                                                    padding: '10px 20px',
                                                    borderRadius: '36px',
                                                    border: `2px solid ${actionColorMap[a.c]?.border || '#2DD4A8'}`,
                                                    background: '#fff',
                                                    fontSize: 13,
                                                    fontWeight: 600,
                                                    color: actionColorMap[a.c]?.color || '#1AAB86',
                                                    textTransform: 'none',
                                                    whiteSpace: 'nowrap',
                                                    transition: 'all 0.3s cubic-bezier(0.34,1.56,0.64,1)',
                                                    '&:hover': {
                                                        transform: 'translateY(-3px) scale(1.04)',
                                                        background: actionColorMap[a.c]?.hoverBg || '#E8FBF5',
                                                    },
                                                }}
                                            >
                                                {a.i} {a.l}
                                            </Button>
                                        ))}

                                    </Box>
                                </Box>
                            </>
                        )}
                    </Box>
                )}
            </Box>
            <Dialog
                open={showVerificationModal}
                onClose={() => setShowVerificationModal(false)}
                maxWidth="xs"
                fullWidth
                BackdropProps={{
                    sx: {
                        backgroundColor: 'rgba(0, 0, 0, 0.7)',
                        backdropFilter: 'blur(8px)',
                    }
                }}
                // PaperProps={{
                //     sx: {
                //         borderRadius: 4,
                //         p: 3,
                //         boxShadow: '0 25px 50px -12px rgba(0, 0, 0, 0.25)',
                //     }
                // }}
                PaperProps={{
                    sx: {
                        borderRadius: 4,
                        p: { xs: 2, sm: 3 },
                        boxShadow: '0 25px 50px -12px rgba(0, 0, 0, 0.25)',
                    }
                }}
            >
                <DialogContent sx={{ p: 0 }}>
                    <Box sx={{ textAlign: 'center', mb: 4 }}>
                        <Typography
                            sx={{
                                fontSize: 20,
                                fontWeight: 700,
                                background: 'linear-gradient(135deg, #22c55e, #14b8a6, #8b5cf6)',
                                WebkitBackgroundClip: 'text',
                                WebkitTextFillColor: 'transparent',
                                backgroundClip: 'text',
                            }}
                        >
                            Account Verification Pending
                        </Typography>
                        <Typography
                            sx={{
                                fontSize: 13,
                                color: '#64748B',
                                mt: 1
                            }}
                        >
                            Complete your account verification in the Profile page to unlock all echoShine features.
                        </Typography>
                    </Box>
                    <Stack spacing={2}>
                        <Button
                            fullWidth
                            variant="contained"
                            onClick={() => {
                                setShowVerificationModal(false);
                                if (storedUser?.status === "unverified") {
                                    navigate("/profile");
                                }
                            }}
                            sx={{
                                py: 1.5,
                                borderRadius: 2,
                                textTransform: "none",
                                fontWeight: 600,
                                background: 'linear-gradient(135deg, #22c55e, #14b8a6, #8b5cf6)',
                                color: '#ffffff',
                                '&:hover': {
                                    background: 'linear-gradient(135deg, #16a34a, #0d9488, #7c3aed)',
                                }
                            }}
                        >
                            Proceed
                        </Button>
                    </Stack>
                </DialogContent>
            </Dialog>
        </Box>
    );
}

export default EchoHome;
